<template>
  <div
    class="evaluation-answer-unique"
    v-if="question.type==='unique'"
  >
    <div
      v-for="answer in question.$answers"
      :key="answer.name"
      class="answer-item"

    >
      <el-radio
        @change="onChange($event, answer)"
        v-model="question.$result"
        :label="answer.$id"
        :disabled="disabled"
      >
        {{ answer.name }}
      </el-radio>
    </div>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationAnswerUnique',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      required: true
    },
    branchType: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.calculateBaseScore()
  },
  methods: {
    calculateBaseScore () {
      this.question.$baseScore = 0
      for (let answer of this.question.$answers) {
        if (answer.$pointsPerBranch) {
          for (let branchPoints of answer.$branchPoints) {
            if (branchPoints.type === this.branchType) {
              if (this.question.$baseScore < branchPoints.points) {
                this.question.$baseScore = branchPoints.points
              }
            }
          }
        } else {
          if (this.question.$baseScore < answer.$points) {
            this.question.$baseScore = answer.$points
          }
        }
      }
    },
    onChange (id, answer) {
      this.$set(
        this.question,
        'innerEvidenceRequired',
        answer.$evidenceRequired
      )
      if (answer.$pointsPerBranch) {
        for (let branchPoints of answer.$branchPoints) {
          if (branchPoints.type === this.branchType) {
            this.question.$points = branchPoints.points
            break
          }
        }
      } else {
        this.question.$points = answer.$points
      }
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
        lang="scss"
        scoped
>
.evaluation-answer-unique {
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/answers/evaluation-answer-unique.vue